import styles from './AppHeader.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { logout } from '@customer/store/slices/authSlice';
import {
  VdsHeader,
  VdsIconButton,
  VdsMenuItem,
  VdsMenuList,
} from '@volt/volt-extended-components-react';
import { openSidePanel, SidePanel } from '@customer/store/slices/globalSlice';
import { Permission, userHasPermission } from '@customer/permissions';
import NotificationsButton from '../notifications-button/NotificationsButton';
import SiteInfo from '../site-info/SiteInfo';
import { useCallback, useState } from 'react';

const divider = (
  <div className={styles.divider}>
    <div className="content_divider_vertical" />
  </div>
);

export function AppHeader() {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  const dispatch = useAppDispatch();

  const onShowHelpPanel = useCallback(() => {
    dispatch(openSidePanel({ sidePanel: SidePanel.Help }));
  }, [dispatch]);

  const onLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const [renderKey, setRenderKey] = useState(0);

  const onChangeSettings = useCallback(() => {
    dispatch(
      openSidePanel({
        sidePanel: SidePanel.UserSettings,
      }),
    );

    // Increment the key so that the header is re-rendered without the menu open.
    // FIXME: This code is a workaround for closing the VdsHeader popup since the component has no methods.
    setRenderKey(prevKey => prevKey + 1);
  }, [dispatch]);

  return (
    <VdsHeader
      key={renderKey}
      className={styles.container}
      value={t('Digital Mine Portal')}
      username={userData.displayName ?? ''}
      avatar={userData.displayName ?? ''}
      showUserSection={userData.isLoggedIn}
    >
      {userData.isLoggedIn ? (
        <>
          <div slot="contentSection" className={styles.content}>
            {userHasPermission(userData, Permission.SiteDataRead) && (
              <>
                <SiteInfo />
                {divider}
              </>
            )}
            <div className={styles.buttons}>
              {userHasPermission(userData, Permission.CanAccess) && <NotificationsButton />}
              <VdsIconButton
                icon="unknown"
                size="medium"
                variant="tertiary"
                onClick={onShowHelpPanel}
              />
            </div>
            {divider}
          </div>

          <div slot="profilePopupContent">
            <VdsMenuList>
              <VdsMenuItem
                isActive={false}
                size="medium"
                icon="system"
                value={t('Settings')}
                onClick={onChangeSettings}
              />
              <VdsMenuItem
                isActive={false}
                size="medium"
                icon="logout"
                value={t('Log out')}
                onClick={onLogout}
              />
            </VdsMenuList>
          </div>
        </>
      ) : (
        // User not authenticated state
        <div slot="contentSection" className={styles.content}>
          <VdsIconButton
            icon="unknown"
            size="medium"
            variant="tertiary"
            onClick={onShowHelpPanel}
          />
        </div>
      )}
    </VdsHeader>
  );
}

export default AppHeader;
